import { render, staticRenderFns } from "./LawTradeFairSubjectList.vue?vue&type=template&id=0855f0fc&"
import script from "./LawTradeFairSubjectList.vue?vue&type=script&lang=js&"
export * from "./LawTradeFairSubjectList.vue?vue&type=script&lang=js&"
import style0 from "./LawTradeFairSubjectList.vue?vue&type=style&index=0&id=0855f0fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports